module.exports = __webpack_public_path__ + "img/sk-partners-dennik-n.03fd88e6.svg";